<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="69.867"
    height="69.867"
    viewBox="0 0 69.867 69.867">
    <g
      id="Icon_ion-add-circle-outline"
      data-name="Icon ion-add-circle-outline"
      transform="translate(-2.5 -2.5)">
      <path
        id="Path_529"
        data-name="Path 529"
        d="M70.367,37.434A32.934,32.934,0,1,0,37.434,70.367,32.942,32.942,0,0,0,70.367,37.434Z"
        fill="none"
        stroke="#57a4ff"
        stroke-width="4" />
      <path
        id="Path_530"
        data-name="Path 530"
        d="M22.131,12.375V31.886m9.756-9.756H12.375"
        transform="translate(15.303 15.303)"
        fill="none"
        stroke="#57a4ff"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="4" />
    </g>
  </svg>
</template>
